// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"429d5491","349":"5d079548","396":"2d5ad3e0","618":"06f1667a","662":"c7bc0a43","760":"1c6fd07c","841":"8acd7412","842":"f4b55168","871":"42a93447"}[chunkId] + ".chunk.js";
};